<template>
  <div class="withdraw-page">
    <!-- 顶部导航 -->
    <div class="withdraw-header">
      <van-icon name="arrow-left" size="20" color="#999" @click="handleBack" />
      <div class="withdraw-tabs">
        <div class="withdraw-tab" :class="{ active: activeTab === 20 }" @click="switchTab(20)">申请提现</div>
        <div class="withdraw-tab" :class="{ active: activeTab === 10 }" @click="switchTab(10)">收款账户</div>
        <div class="withdraw-tab" :class="{ active: activeTab === 3 }" @click="switchTab(3)">提现记录</div>
      </div>
      <img class="withdraw-kefu" src="/static/newImg/deposit/comm_icon_cz_kf.svg" @click="$router.push({ path: '/notice', query: { noticeType: '4', from: 'mine' } })" />
    </div>

    <!-- 子页面内容 -->
    <div class="withdraw-content">
      <ApplyWithdraw v-if="activeTab === 20" :accountCount="accountCount" :accountList="accountList" @goAccount="switchTab(10)" />
      <AccountList ref="accountList" v-if="activeTab === 10" @bindNo="onBindNo" @addCrypto="onAddCrypto" @addThird="onAddThird" @addBank="onAddBank" @addAlipay="onAddAlipay" @delete="onDeleteAccount" @countChange="onAccountCountChange" />
      <WithdrawRecord v-if="activeTab === 3" />
    </div>

    <!-- 密码弹框 -->
    <PasswordPopup ref="passwordPopup" :visible="showPasswordPopup" @close="showPasswordPopup = false" @submit="onPasswordSubmit" />

    <!-- 添加数字货币弹框 -->
    <AddCryptoPopup :visible="showAddCrypto" :password="pendingPwd" @close="onAddPopupClose('crypto')" @added="refreshAccountList" @needReauth="onAddNeedReauth('crypto')" />
    <!-- 添加三方钱包弹框 -->
    <AddThirdPopup :visible="showAddThird" :password="pendingPwd" @close="onAddPopupClose('third')" @added="refreshAccountList" @needReauth="onAddNeedReauth('third')" />
    <!-- 添加银行卡弹框 -->
    <AddBankPopup :visible="showAddBank" :password="pendingPwd" @close="onAddPopupClose('bank')" @added="refreshAccountList" @needReauth="onAddNeedReauth('bank')" />
    <!-- 添加支付宝弹框 -->
    <AddAlipayPopup :visible="showAddAlipay" :password="pendingPwd" @close="onAddPopupClose('alipay')" @added="refreshAccountList" @needReauth="onAddNeedReauth('alipay')" />
  </div>
</template>

<script>
import ApplyWithdraw from './ApplyWithdraw.vue';
import AccountList from './AccountList.vue';
import WithdrawRecord from './WithdrawRecord.vue';
import PasswordPopup from './PasswordPopup.vue';
import AddCryptoPopup from './AddCryptoPopup.vue';
import AddThirdPopup from './AddThirdPopup.vue';
import AddBankPopup from './AddBankPopup.vue';
import AddAlipayPopup from './AddAlipayPopup.vue';

export default {
  name: 'Withdraw',
  components: {
    ApplyWithdraw,
    AccountList,
    WithdrawRecord,
    PasswordPopup,
    AddCryptoPopup,
    AddThirdPopup,
    AddBankPopup,
    AddAlipayPopup,
  },
  data() {
    return {
      activeTab: 20,
      accountCount: 0,
      accountList: [],
      showPasswordPopup: false,
      fromHome: false,
      pendingAction: '', // crypto/third/bank/alipay/delete:xxx
      pendingDeleteItem: null,
      pendingPwd: '', // 刚验证通过的提现密码（明文），直接传给 Add*Popup，失败重试不用再输
      showAddCrypto: false,
      showAddThird: false,
      showAddBank: false,
      showAddAlipay: false,
    };
  },
  created() {
    const q = this.$route.query || {};
    if (q.active) {
      this.activeTab = parseInt(q.active);
    }
    if (q.from === 'home') {
      this.fromHome = true;
    }
    this.fetchAccountCount();
  },
  watch: {
    '$route.query.active'(val) {
      if (val) {
        this.activeTab = parseInt(val);
      }
    },
  },
  methods: {
    // 统一 toast：优先找父级 showTost，兜底 _domToast，不用原生 alert
    toast(msg, type = 0) {
      let p = this.$parent;
      while (p) {
        if (typeof p.showTost === 'function') {
          p.showTost(type, msg);
          return;
        }
        p = p.$parent;
      }
      if (this.$notify) {
        this.$notify({ type: type ? 'success' : 'danger', message: msg, zIndex: 999999, duration: 2500 });
        return;
      }
      if (this.$toast) {
        try { this.$toast({ message: msg, zIndex: 999999, position: 'top' }); } catch (_) { this.$toast(msg); }
        return;
      }
      this._domToast(msg);
    },
    _domToast(msg) {
      try {
        if (!msg) return;
        const el = document.createElement('div');
        el.textContent = msg;
        Object.assign(el.style, {
          position: 'fixed', top: '40%', left: '50%', transform: 'translateX(-50%)',
          background: 'rgba(0,0,0,0.78)', color: '#fff', padding: '0.24rem 0.35rem',
          borderRadius: '0.1rem', fontSize: '0.3rem', zIndex: '999999',
          maxWidth: '80%', textAlign: 'center', pointerEvents: 'none',
        });
        document.body.appendChild(el);
        setTimeout(() => { try { document.body.removeChild(el); } catch (_) {} }, 1500);
      } catch (_) {}
    },
    handleBack() {
      if (this.fromHome) {
        this.$router.push('/').catch(() => {});
      } else {
        this.$router.back();
      }
    },
    switchTab(tab) {
      this.activeTab = tab;
      const query = { active: tab };
      if (this.fromHome) {
        query.from = 'home';
      }
      this.$router.replace({ path: '/withdraw', query });
    },
    // 每次触发需要密码的操作前，先清掉遗留的 verify_token，确保必须重新走密码校验
    clearCachedVerifyToken() {
      try {
        sessionStorage.removeItem('wd_verify_token');
      } catch (_) {}
    },
    onBindNo() {
      this.clearCachedVerifyToken();
      this.showPasswordPopup = true;
    },
    onAddCrypto() {
      this.clearCachedVerifyToken();
      this.pendingPwd = ''; // 每次点添加都强制清密码 → 必须重新弹密码验证
      this.pendingAction = 'crypto';
      this.showPasswordPopup = true;
    },
    onAddThird() {
      this.clearCachedVerifyToken();
      this.pendingPwd = '';
      this.pendingAction = 'third';
      this.showPasswordPopup = true;
    },
    onAddBank() {
      this.clearCachedVerifyToken();
      this.pendingPwd = '';
      this.pendingAction = 'bank';
      this.showPasswordPopup = true;
    },
    onAddAlipay() {
      this.clearCachedVerifyToken();
      this.pendingPwd = '';
      this.pendingAction = 'alipay';
      this.showPasswordPopup = true;
    },
    onDeleteAccount(item) {
      const delId = item && item.id ? (item.id | 0) : 0;
      if (!delId) return;
      const name = (item && item.category_name) || (item && item.type_name) || '该账户';
      if (typeof window !== 'undefined' && window.confirm) {
        const ok = window.confirm('确认删除' + name + '？删除后不可恢复');
        if (!ok) return;
      }
      this.clearCachedVerifyToken();
      this.pendingPwd = '';
      this.pendingDeleteItem = item;
      this.pendingAction = 'delete:' + delId;
      this.showPasswordPopup = true;
    },
    onAddPopupClose(type) {
      // 关闭 Add 弹框时不清 pendingPwd，只有"再次点添加按钮"时才清（强制重新验证密码）
      switch (type) {
        case 'crypto': this.showAddCrypto = false; break;
        case 'third':  this.showAddThird  = false; break;
        case 'bank':   this.showAddBank   = false; break;
        case 'alipay': this.showAddAlipay = false; break;
      }
    },
    onAddNeedReauth(type) {
      // Add 弹框里提交时发现密码错了/没传 → 关闭弹框，再次弹 PasswordPopup 重新输入
      this.pendingPwd = '';
      switch (type) {
        case 'crypto': this.showAddCrypto = false; this.pendingAction = 'crypto'; break;
        case 'third':  this.showAddThird  = false; this.pendingAction = 'third';  break;
        case 'bank':   this.showAddBank   = false; this.pendingAction = 'bank';   break;
        case 'alipay': this.showAddAlipay = false; this.pendingAction = 'alipay'; break;
      }
      this.$nextTick(() => {
        setTimeout(() => { this.showPasswordPopup = true; }, 50);
      });
    },
    refreshAccountList() {
      this.fetchAccountCount();
      if (this.$refs.accountList && typeof this.$refs.accountList.loadList === 'function') {
        this.$refs.accountList.loadList();
      }
    },
    onAccountCountChange(count, list) {
      this.accountCount = count;
      if (list) this.accountList = list;
    },
    fetchAccountCount() {
      this.$apiFun.post('/api/userCards/list', {}).then((res) => {
        if (res.code === 200) {
          const list = (res.data && res.data.list) || [];
          this.accountCount = list.length;
          this.accountList = list;
        }
      }).catch(() => {});
    },
    doDeleteAccount(id) {
      const that = this;
      this.$apiFun.post('/api/userCards/delete', { id: id }).then((res) => {
        if (res.code === 200) {
          that.toast('删除成功', 1);
          that.fetchAccountCount();
          that.refreshAccountList();
        } else {
          that.toast(res.message || res.msg || '删除失败');
        }
      }).catch(() => {
        that.toast('网络异常，请稍后重试');
      });
    },
    onPasswordSubmit(password) {
      const action = this.pendingAction;
      const that = this;

      // 先调后端独立的提现密码校验接口，通过才打开对应弹框
      that.$apiFun
        .post('/api/withdraw/verifyPassword', { password: password })
        .then((res) => {
          if (res.code === 200) {
            that.showPasswordPopup = false;
            // 缓存明文密码，直接传给 Add*Popup 的 props.password
            // 失败重试不用再弹密码；只有下次"点击添加按钮"时 pendingPwd 才会被清空，强制重新验证
            that.pendingPwd = password;
            that.pendingAction = '';
            that.$nextTick(() => {
              setTimeout(() => {
                if (action && action.indexOf('delete:') === 0) {
                  const id = parseInt(action.slice('delete:'.length), 10);
                  that.pendingDeleteItem = null;
                  if (id) that.doDeleteAccount(id);
                  return;
                }
                switch (action) {
                  case 'crypto':
                    that.showAddCrypto = true;
                    break;
                  case 'third':
                    that.showAddThird = true;
                    break;
                  case 'bank':
                    that.showAddBank = true;
                    break;
                  case 'alipay':
                    that.showAddAlipay = true;
                    break;
                  default:
                    that.toast('密码验证成功', 1);
                }
              }, 50);
            });
          } else {
            // 密码错误/未设置，保留密码弹框让用户继续输入或去设置
            if (res.data && res.data.has_paypwd === false) {
              // 未设置提现密码，关闭密码弹框，提示去设置
              that.showPasswordPopup = false;
              that.pendingAction = '';
              that.toast(res.message || res.msg || '请先设置提现密码');
            } else {
              // 密码输入错误，让 PasswordPopup 清空继续输入
              if (that.$refs.passwordPopup) {
                that.$refs.passwordPopup.clearInput();
              }
              that.toast(res.message || res.msg || '提现密码不正确');
            }
          }
        })
        .catch(() => {
          that.showPasswordPopup = false;
          that.pendingAction = '';
          that.toast('网络异常，请稍后重试');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.withdraw-page {
  min-height: 100vh;
  background: #1a1a1a;
  padding-bottom: 1rem;
}

.withdraw-header {
  display: flex;
  align-items: center;
  padding: 0.2rem 0.3rem;
  position: sticky;
  top: 0;
  background: #1a1a1a;
  z-index: 100;
}

.withdraw-tabs {
  display: flex;
  flex: 1;
  justify-content: flex-start;
  gap: 0.4rem;
  margin-left: 0.2rem;
}

.withdraw-tab {
  font-size: 0.35rem;
  color: #fff;
  cursor: pointer;
  padding: 0.1rem 0;
  position: relative;

  &.active {
    color: #DFB372;
    font-weight: bold;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0.6rem;
      height: 2px;
      background: #DFB372;
      border-radius: 2px;
    }
  }
}

.withdraw-kefu {
  width: 0.55rem;
  height: 0.55rem;
  cursor: pointer;
  margin-left: 0.2rem;
}

.withdraw-content {
  padding-top: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/view/withdraw/withdraw.vue